// src/chains/celo.js - Celo Mainnet configuration with SushiSwap API support
import { createChainConfig } from './chainConfig';

export const celoConfig = createChainConfig({
  key: 'celo',
  chainId: 42220,
  name: 'Celo Mainnet',
  rpcUrl: 'https://1rpc.io/celo',
  explorerUrl: 'https://celoscan.io',
  
  // Native token information
  nativeTokenSymbol: 'CELO',
  nativeTokenName: 'Celo',
  nativeTokenIcon: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/celo/info/logo.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x471EcE3750Da237f93B8E339c536989b8978a438', // Wrapped CELO
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=celo&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'celo',
  geckoTerminalId: 'celo',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/celo.json',
  
  // SushiSwap configuration
  aggregatorAddress: 'SushiSwap',
  sushiswapConfig: {
    apiBaseUrl: 'https://api.sushi.com',
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' // Celo SushiSwap router
  },
  
  // Legacy aggregator reference (e.g., Ubeswap)
  legacyAggregatorAddress: '0xE3D8bd6Aed4F159bc8000a9cD47CffDb95F96121', // Ubeswap router
  
  // Transaction support
  supportsEIP1559: false, 
  
  // Transaction history API
  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/42220/address/{address}/transactions'
});